import { Output, Input, EventEmitter, Component } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { faCheckDouble } from '@fortawesome/free-solid-svg-icons';
import { AppConstants } from 'src/app/core/constants';

@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.scss',],
})
export class OtpComponent {

  @Input() length: number = AppConstants.DEFAULT_OTP_LENGTH;

  otpForm: UntypedFormControl = new UntypedFormControl('', [
    Validators.required,
    Validators.minLength(this.length),
    Validators.maxLength(this.length),
    Validators.pattern('[0-9]'),
  ]);

  @Output() verifyOtpEvent = new EventEmitter<string>();

  @Input() otpVerified: boolean = false;

  faCheckDouble = faCheckDouble;

  onSubmit() {
    const otp = this.otpForm.value;
    this.verifyOtpEvent.emit(otp);
  }
}